import { toPastTense } from "@/lib/utils";
import { twMerge } from "tailwind-merge";
import { StepIcon } from "./step-icon";

interface StepLabelProps {
    errorStep: number;
    step: number;
    currentStep: number;
    children: React.ReactNode;
  }
  
  export function StepLabel({ errorStep, step, currentStep, children }: StepLabelProps) {
    const isError = step === errorStep;
    const className = twMerge(
      "text-muted-foreground",
      isError
        ? "text-destructive"
        : step === currentStep
        ? "text-primary"
        : step > currentStep
        ? "text-muted-foreground/50"
        : null
    );
    return (
      <div className={`flex items-center ${className}`}>
        <StepIcon
          errorStep={errorStep}
          step={step}
          currentStep={currentStep}
          className={`mr-1 ${className}`}
        />
        {step < currentStep ? toPastTense(children!.toString()) : children}
      </div>
    );
  }